import type { IconSvgObject } from './types';

const ArrowDownToLineIcon: IconSvgObject = [
  ["path", { d: "M12 16V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 21H18", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 12C7 12 10.6824 17 12 17C13.3176 17 17 12 17 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArrowDownToLineIcon;
